<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .add-to-campaign-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: utils.in_rem(24px);
    border-bottom: 1px solid colors.get(interfaceSwGrey_10);
    padding-bottom: utils.in_rem(24px);
    .h4 {
      font-weight: 100;
      font-size: utils.in_rem(14px);
      @include colors.color(black_90);

      font-family: Lato;
      font-size: utils.in_rem(14px);
      font-style: normal;
      font-weight: 700;
      line-height: utils.in_rem(20px);
      letter-spacing: utils.in_rem(0.28px);
    }
  }

  .campaign-select-button {
    overflow: hidden;
    @include colors.color(black_90);
    text-overflow: ellipsis;
    font-family: Lato;
    font-size: utils.in_rem(14px);
    font-style: normal;
    font-weight: 400;
    line-height: utils.in_rem(21px);
    letter-spacing: utils.in_rem(0.28px);
    display: flex;
    width: utils.in_rem(237px);
  }
</style>

<script>
  // Stores
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import {
    campaignOptions,
    openCampaignsStore,
    selectedCampaignIdStore,
  } from "./stores";
  // Components
  import GroupedSingleSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/SingleSelectDropdown/GroupedSingleSelectDropdown.svelte";

  let selected;
  let closeDropdown;

  const { meta } = openCampaignsStore;

  if (!$meta.fetching && !$meta.firstFetchDone) {
    openCampaignsStore.get();
  }

  $: userCampaigns = $campaignOptions.filter(
    (campaign) => campaign.creatorUserId === $userStore.userId
  );

  $: teammatesCampaigns = $campaignOptions.filter(
    (campaign) => campaign.creatorUserId !== $userStore.userId
  );

  $: groups = [
    {
      title: "Your Campaigns",
      items: userCampaigns,
    },
    {
      title: "Teammates' Campaigns",
      items: teammatesCampaigns,
    },
  ];

  $: selectedCampaignIdStore.set(selected);
</script>

<div class="add-to-campaign-container">
  <h4>Add to Campaign</h4>
  <GroupedSingleSelectDropdown
    style="width: 400px"
    placeholderIcon="fa-regular fa-megaphone"
    placeholder="Select a campaign"
    {groups}
    bind:close={closeDropdown}
    bind:selected
    disabled={$meta.fetching || !$meta.firstFetchDone}
    showFilter
  />
</div>
